import useEmployerProducts from "./useEmployerProducts";
import useLoginInfo from "hooks/useLoginInfo";

const useRouteAccess = () => {
    const {userInfo} = useLoginInfo();
    const {isOnDemandUser, isPayrollUser} = useEmployerProducts();
    const employerId = userInfo?.employer?.id;
    const completedPayrollOnboarding = localStorage.getItem(`completedPayrollOnboarding-${employerId}`);
    
    let isOnboardingRequired = !userInfo?.employer?.adminVerify;
    let isOnDemandOnboardingRequired = !isOnDemandUser;
    const isPayrollOnboardingRequired = !isPayrollUser && !completedPayrollOnboarding;
    const isPayrollOdpCreditRestricted = userInfo?.company?.companyType !== "registered business";
    
    return {isOnboardingRequired, isOnDemandOnboardingRequired, isPayrollOnboardingRequired, isPayrollOdpCreditRestricted};
}

export default useRouteAccess